
import { defineComponent } from 'vue'
import WorkspaceDropdown from '@/components/WorkspaceDropdown.vue'
import ActionButton from '@/components/ActionButton.vue'
import { createBoardService } from '@/services/board'
import { Form, Field, FormActions } from 'vee-validate'

export default defineComponent({
  components: {
    WorkspaceDropdown,
    ActionButton,
    Form,
    Field
  },
  data () {
    return {
      name: undefined,
      showCreateBoardDD: false
    }
  },
  methods: {
    async handleCreateBoard (values: unknown, actions: FormActions<Record<string, unknown>>) {
      try {
        const res = await createBoardService({ name: this.name })
        if (!res.error) {
          this.name = undefined
          this.showCreateBoardDD = false
          this.$store.commit('ADD_CREATED_BOARD', res.data)
        }
      } catch (error) {
        this.$setErrors(error, actions)
      }
    }
  }
})
